import xs from "xstream"
import { div, label, button, hr } from "@cycle/dom"
import * as R from "ramda"

import {
  AddressForm,
} from "../../../../interface"

import {
  createTextArea,
  createTextInput,
} from "../../../common"
import { MODIFY_MSG } from "../../../../constant"

export const view = (
  userForm$: xs<AddressForm>,
  errorCheck$: xs<any>,
  _zipMsg$ = xs.never(),
  readOnly = false,
) =>
  xs
    .combine(userForm$, errorCheck$)
    .map(
      ([userForm, errorCheck]: [
        AddressForm,
        any,
      ]) => {
        const disabled = R.find(
          (arr) => arr[1].check === false,
          R.toPairs(errorCheck),
        )
          ? true
          : false
        const gutter = readOnly ? "" : ".g-3"
        return div([
          div(".form.mt-2", [
            readOnly ? null : div(".row", [
              div(".col-md-6.caution", ["※は必須入力です。"]),
            ]),
            div(`.row${gutter}`, [
              createTextInput("lastName", readOnly)(userForm, errorCheck),
              createTextInput("firstName", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [
              createTextInput("lastNameYomi", readOnly)(userForm, errorCheck),
              createTextInput("firstNameYomi", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [
              createTextInput("lastNameEng", readOnly)(userForm, errorCheck),
              createTextInput("firstNameEng", readOnly)(userForm, errorCheck),
              createTextInput("middleNameEng", readOnly)(userForm, errorCheck),
            ]),
            hr(),
            label(".form-label.fw-bold", ["所属学会・会員番号"]),
            readOnly ? null : div(".form-text.mt-0", [
              div(["生殖医療専門医・生殖医療専攻医の先生は、ご登録いただきますと単位・ポイント付与の際に確実に連携されます。"]),
              div(["誤入力されますと、本人確認ができず、付与されない場合がございますので、番号のお間違えにはご留意ください。"]),
            ]),
            readOnly ? null : div(".caution.mt-0", [MODIFY_MSG]),
            div(`.row${gutter}.mt-1`, [
              createTextInput("jsog", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [createTextInput("jua", readOnly)(userForm, errorCheck)]),
            hr(),
            div(`.row${gutter}`, [createTextArea("bikou", readOnly)(userForm, errorCheck)]),
            div(".d-grid.gap-3.mt-4", [
              div(".col.col-md-4", [
                readOnly
                  ? button(
                    "#btnSend.btn.btn-danger.w-100",
                    { props: { disabled: disabled } },
                    ["変更申請を行う"],
                  )
                  : button(
                    "#btnConfirm.btn.btn-primary.w-100",
                    { props: { disabled: disabled } },
                    ["申請内容を確認する"],
                  ),
              ]),
              div(".col.col-md-4", [
                button( "#btnReturn.btn.btn-success.w-100", ["戻る"]),
              ]),
            ]),
          ]),
        ])
      },
    )
